import React from 'react';
import { makeStyles } from '@material-ui/core';
import CompetitorAPI from '../../api/Competitor';
import { get, map } from 'lodash';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    flexShrink: 1,
    height: 'fit-content',
    zIndex: 3
  }
}));

function AliasFilter(props) {
  const classes = useStyles();

  /**
   * @description Asynchronously searches for an alias rough match
   * @param {string} search - Alias to search for %rough%
   * @returns {object} - Array of { label: alias.name, value: alias._id }
   */
  async function loadAlias(search) {
    const response = await CompetitorAPI.getAllCompetitors({
      search
    }).catch(props.onError);

    return map(response.competitors.rows, r => ({
      value: r._id,
      label: r.alias
    }));
  }

  return (
    <AsyncSelect
      aria-label="Alias Filter"
      className={clsx({
        [classes.root]: !props.className,
        [props.className]: props.className
      })}
      isMulti={props.isMulti}
      cacheOptions
      defaultOptions
      blurOnInputSelect={false}
      closeMenuOnSelect={true}
      isClearable={props.isClearable}
      placeholder={props.placeholder}
      loadOptions={loadAlias}
      onChange={props.onChange}
      menuPlacement="auto"
      styles={props.styles ?? undefined}
      components={props.components ?? undefined}
      value={get(props, 'value.value') ? props.value : undefined}
      menuPortalTarget={document.body}
      menuPosition={'fixed'}
    />
  );
}

AliasFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  styles: PropTypes.object,
  components: PropTypes.object,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  value: PropTypes.object
};

AliasFilter.defaultProps = {
  onError: console.error,
  isMulti: true,
  placeholder: 'Alias',
  isClearable: true
};

export default AliasFilter;
